import { STOCK_STATUS } from '@/constants/stock.js'

export function getStockColour(status) {
  const keys = Object.keys(STOCK_STATUS)
  return STOCK_STATUS[keys[status?.status - 1]]
}
